import { render, staticRenderFns } from "./DataTableComponent.vue?vue&type=template&id=6730d3b2&scoped=true"
import script from "./DataTableComponent.vue?vue&type=script&lang=js"
export * from "./DataTableComponent.vue?vue&type=script&lang=js"
import style0 from "./DataTableComponent.vue?vue&type=style&index=0&id=6730d3b2&prod&scoped=true&lang=css"
import style1 from "./DataTableComponent.vue?vue&type=style&index=1&id=6730d3b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6730d3b2",
  null
  
)

export default component.exports